<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://', v-if='params')
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                   | {{ $i18n.t('trainer.trainer_gameFormSetting_shutterMode') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='gameModes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                        v-model='selectedGameMode',
                        @select='params.mode = $event.value'
                    )
            .form__field(v-if="params.mode !== 'text' && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_groups') }}
                .form__field-body
                    cs-multiselect(
                        :options="groups"
                        :show-labels="false"
                        :hide-selected="true"
                        :max="null"
                        :close-on-select="false"
                        :clear-on-select="false"
                        placeholder=""
                        :multiple="true"
                        v-model="params.selectedGroups"
                        :disabled="groups.length === 0"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="groups"
                        :data-vv-as="$i18n.t('homework.homework_create_studentsVvSs')"
                        class="multiple-multiselect"
                    )
            .form__field(v-if="params.mode !== 'text' && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAllGroups') }}
                .form__field-body
                    cs-checkbox(
                        :checked="groups.length === params.selectedGroups.length"
                        @change="toggleGroups"
                    )
            .form__field(v-if="showWordConstitutingLettersFields")
                label.form__label
                    | {{ $i18n.tc('trainer.trainer_gameFormSetting_letters', 1) }}
                .form__field-body
                    cs-multiselect(
                        :options="letters"
                        :show-labels="false"
                        :hide-selected="true"
                        :max="null"
                        :close-on-select="false"
                        :clear-on-select="false"
                        placeholder=""
                        :multiple="true"
                        v-model="params.wordConstitutingLetters"
                        :disabled="letters.length === 0"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="letters"
                        :data-vv-as="letters"
                        class="multiple-multiselect"
                    )
            .form__field(v-if="showWordConstitutingLettersFields")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAllLetters') }}
                .form__field-body
                    cs-checkbox(
                        :checked='wordConstitutingLettersLength === letters.length',
                        @change="toggleWordConstitutingLetters"
                    )
            div(v-if="selectedSyllableGroupsWithTwoLetters && slug === 'ShutterOnline'"
                v-for="(group, index) in selectedSyllableGroupsWithTwoLetters" :key="index")
                .form__field(v-if="params.mode !== 'text' && gameMode !== 'course' && gameMode !== 'generator-settings' && selectedSyllableGroupsWithTwoLetters")
                    label.form__label
                        | {{ group.name }}
                    .form__field-body
                        cs-multiselect(
                            :options="group.letters"
                            :show-labels="false"
                            :hide-selected="true"
                            :max="null"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :multiple="true"
                            placeholder=""
                            v-model="params[group.name]"
                            v-validate="'required'"
                            data-vv-value-path="innerValue"
                            data-vv-name="groups"
                            :data-vv-as="$i18n.t('homework.homework_create_studentsVvSs')"
                            class="multiple-multiselect"
                        )
                .form__field(v-if="selectedSyllableGroupsWithTwoLetters")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAllLetters') }}
                    .form__field-body
                        cs-checkbox(
                            :checked="checkedValue(group.name)"
                            @change="selectAllLettersForGroup(group.name)"
                        )
            .form__field(v-if="params.mode === 'text' && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_shutterTextInput') }}
                .form__field-body.select-text
                    div
                        a(href="javascript://", @click="showManualInputModal = true" :class="{'is-selected': !selectedText && params.textLabel && params.sourceText}")
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_manualInput') }}
                        span &nbsp; {{ $i18n.t('games.games_or') }} &nbsp;
                        a(href="javascript://" @click="showSelectTextModal = true" :class="{'is-selected': selectedText}")
                            | {{ $i18n.t('games.games_gameSettings_selectFromLoaded') }}
                    div.source-text(v-if="params.sourceText") {{ params.sourceText }}
            .form__field(v-if="params.mode !== 'text' && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                   | {{ amountOfItemsString }}
                .form__field-body
                    cs-spin-input(
                        :value="params.amountOfItemsInColumn",
                        :max="amountOfItemsInColumn",
                        :min="1",
                        @increase="increaseAmountOfItemsInColumn",
                        @decrease="decreaseAmountOfItemsInColumn",
                        @input="params.amountOfItemsInColumn = $event",
                    )
            .form__field(v-if="params.mode === 'text' && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInRow') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.amountOfWordsInRow",
                        :max="amountOfWordsInRow",
                        :min="1",
                        @increase="increaseAmountOfWordsInRow",
                        @decrease="decreaseAmountOfWordsInRow",
                        @input="params.amountOfWordsInRow = $event",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_shutterSpeed') }}
                .form__field-body
                    cs-multiselect(
                        :options="speeds"
                        v-model="params.shutterSpeed"
                        label="value"
                        :placeholder="speedLabel(params.shutterSpeed)"
                        :custom-label="speedLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field
                label.form__label
                    | {{ invertedItemsString }}
                .form__field-body
                    cs-checkbox(
                        v-model="params.invertedItems"
                    )
            .form__field
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_shutterSpeedIncrease') }}
                .form__field-body
                    cs-checkbox(
                        v-model="params.shutterSpeedIncrease"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings' && params && params.shutterSpeedIncrease")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_maxSpeed') }}
                .form__field-body
                    span.warning(
                        v-if="params && params.shutterMaxSpeed.showTime === params.shutterSpeed.showTime"
                        v-text="$i18n.t('trainer.trainer_gameFormSetting_selectSlowerSpeed')"
                    )
                    div(v-else)
                        cs-multiselect(
                            :options="speeds.filter(amount => amount.showTime < params.shutterSpeed.showTime)"
                            v-model="params.shutterMaxSpeed"
                            label="value"
                            :placeholder="speedLabel(params.shutterSpeed)"
                            :custom-label="speedLabel"
                            :multiple="false"
                            :allow-empty="false"
                        )
            metronome-setting(
                :game-mode="gameMode",
                :metronome-speed="+params.metronomeSpeed",
                @updateSpeed="updateMetronomeSpeed"
            )
            divider
            slot(name='parameters')
            //slot(name='help')
            template(v-if='!usersIds')
                .form__buttons
                    cs-button.form__button(pattern="primary-outline" color="blue" @click='cancel')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                    template(v-if="gameMode && gameMode === 'free-game'")
                        cs-button.form__button(color="blue" @click='handleSaveGameMethod(saveGameMode)'
                            :disabled="isSaveButtonDisabled"
                        )
                           | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                    template(v-else='')
                        cs-button.form__button(color="blue" @click='handleSaveGameMethod(saveGame)'
                            :disabled="isSaveButtonDisabled"
                        )
                           | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            template(v-else='')
                .form__buttons
                    cs-button.form__button(color="blue" @click='cancel')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                    cs-button.form__button(pattern="primary-outline" color="blue" @click='handleSaveGameMethod(saveGame)'
                        :disabled="isSaveButtonDisabled"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
        cs-modal(v-if="showManualInputModal", @close="closeManualInputModal")
            div(slot="header") {{ $i18n.t('trainer.trainer_gameFormSetting_manualInput_modalTitle') }}
            div.trainer-modal-content
                span.trainer-modal-content__language-selector(v-text="$i18n.t('trainer.trainer_gameFormSetting_textLanguage')")
                cs-multiselect.trainer-modal-content__language-multiselect(
                    :multiple='false'
                    :options='locales'
                    :show-labels='false'
                    :allow-empty='false'
                    :custom-label='getLocaleName'
                    v-model='params.textLanguage'
                    :searchable='false'
                    v-validate="'required'"
                    name='locale'
                    :data-vv-as="$i18n.t('user.user_form_languageDataVvSs')"
                )
                cs-input(type="text", v-model="params.textLabel", :placeholder="$i18n.t('trainer.trainer_textsModal_textLabel')")
            div.trainer-modal-content
                textarea.trainer-modal-content__textarea(v-model="params.sourceText", :placeholder="$i18n.t('trainer.trainer_textsModal_textInput')")
            div.trainer-modal-button
                cs-button(color="blue" @click="showManualInputModal = false") {{ $i18n.t('trainer.trainer_gameFormSetting_saveChanges') }}
        cs-modal(v-if="showSelectTextModal", @close="closeSelectTextModal")
            div(slot="header") {{ $i18n.t('trainer.trainer_gameFormSetting_selectModal_modalTitle') }}
            div.trainer-modal-content(style="min-height: 19vh;")
                span.trainer-modal-content__language-selector(v-text="$i18n.t('trainer.trainer_gameFormSetting_textLanguage')")
                cs-multiselect.trainer-modal-content__language-multiselect(
                    :multiple='false'
                    :options='locales'
                    :show-labels='false'
                    :allow-empty='false'
                    :custom-label='getLocaleName'
                    v-model='params.textLanguage'
                    :searchable='false'
                    v-validate="'required'"
                    name='locale'
                    :data-vv-as="$i18n.t('user.user_form_languageDataVvSs')"
                )
                div.trainer-modal-content__noTextsMessage(
                    v-if="textsAccordingToLanguage.length === 0",
                    v-text="$i18n.t('trainer.trainer_gameFormSetting_noTexts')"
                )
                div.trainer-modal-content__text-item(
                    v-else
                    v-for="(text, index) in textsAccordingToLanguage"
                    :class="{'trainer-modal-content__text-item--selected': text.content === params.sourceText}"
                )
                    div.trainer-modal-content__text-item__title(@click="resizeText(index)")
                        div {{ text.label }}
                        span.trainer-modal-content__text-item__resize__box
                            i.fa.fa-angle-double-down(v-if="!isTextOpened(index)")
                            i.fa.fa-angle-double-up(v-else)
                    template(v-if="isTextOpened(index)")
                        div(@click="handleClickOnText(text)")
                            div.trainer-modal-content__text-item__content(v-for="line in lines(text)") {{ line }}
            div.trainer-modal-button(v-if="textsAccordingToLanguage.length")
                cs-button(color="blue" @click="showSelectTextModal = false") {{ $i18n.t('trainer.trainer_gameFormSetting_saveChanges') }}

</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _, {clone} from "lodash";
    import IntervalConfig from "../../trainer/configs/IntervalConfig";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";
    import checkIfEnoughWordsBeforeSave from "../../../utils/trainer/checkIfEnoughWordsBeforeSave";
    import ShutterApi from '../../../api/games/shutterReadingEnApi';
    import MetronomeSetting from "../MetronomeSetting.vue"

    const SECONDS_IN_MINUTE = 60;

    export default {
    props: [
        'slug',
        'courseType',
        'id',
        'usersIds',
        'homeworkId',
        'gameMode',
        'levelAnswerDuration',
        'gameId',
        'generatorSettings',
        'generatorGameIndex'
    ],
    components: {
      MetronomeSetting
    },
    mixins: [GameFormMixin, multiplayerFormMixin],
    data () {
        return {
            gameModes: [
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeWordColumn'),
                    value: 'wordColumn'
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeText'),
                    value: 'text'
                }
            ],
            amountOfItemsInColumn: 100,
            amountOfWordsInRow: 15,
            seconds: IntervalConfig.secondsForShutter,
            selectedGameMode: null,
            wordGroups: [],
            syllableGroups: [],
            params: null,
            texts: [],
            showManualInputModal: false,
            showSelectTextModal: false,
            openedTexts: [],
            locales: ['en'],
            localeNames: {en: 'English'},
            letters: [
                'А','Б','В','Г','Д','Е','Ё','Ж','З','И','Й','К','Л','М','Н','О','П',
                'Р','С','Т','У','Ф','Х','Ц','Ч','Ш','Щ','Ъ','Ы','Ь','Э','Ю','Я'
            ],
            groupOne: ['А', 'О', 'У', 'Ы', 'Э', 'б', 'в', 'г', 'д', 'ж', 'з', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ'],
            groupTwo: ['Я', 'Ё', 'Ю', 'И', 'Е', 'б', 'в', 'г', 'д', 'ж', 'з', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ'],
            groupThree: ['А', 'О', 'У', 'Ы', 'Э', 'б', 'в', 'г', 'д', 'ж', 'з', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ'],
            groupFour: ['Я', 'Ё', 'Ю', 'И', 'Е', 'б', 'в', 'г', 'д', 'ж', 'з', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ'],
        }
    },
    mounted() {
        this.getGroups();
        this.getTexts();
        if (this.gameMode === 'free-game') {
            let paramsArray = this.$store.state.trainer.paramsArray;
            if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                this.paramsArray = _.cloneDeep(paramsArray);
                this.$emit('playersNumber', this.paramsArray.length);
                this.params = this.paramsArray[0];
            } else if (this.gamesParameters) {
                this.$set(this, 'params', getInitParameters({
                    slug: this.slug,
                    parameters: {
                      default: _.cloneDeep(this.gamesParameters[this.slug])
                    }
                }));
            } else {
                this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
            }
        } else {
            this.setInitParams(this.getKey(this.usersIds));
        }
        this.selectedGameMode = _.find(this.gameModes, { value: this.params.mode });
        this.params.textLanguage = 'en';
        if (!this.params['Группа 1 (ма, ро)'] && this.params['группа1МаРо']) {
            this.$set(this.params, 'Группа 1 (ма, ро)', _.cloneDeep(this.params['группа1МаРо']));
        }
        if (!this.params['Группа 2 (мя, ки)'] && this.params['группа2МяКи']) {
            this.$set(this.params, 'Группа 2 (мя, ки)', _.cloneDeep(this.params['группа2МяКи']));
        }
        if (!this.params['Группа 3 (ам, ор)'] && this.params['группа3АмОр']) {
            this.$set(this.params, 'Группа 3 (ам, ор)', _.cloneDeep(this.params['группа3АмОр']));
        }
        if (!this.params['Группа 4 (ям, ер)'] && this.params['группа4ЯмЕр']) {
            this.$set(this.params, 'Группа 4 (ям, ер)', _.cloneDeep(this.params['группа4ЯмЕр']));
        }
    },
    methods: {
        getLocaleName () {
            return 'English';
        },
        resizeText (index) {
            if (this.openedTexts.includes(index)) {
                this.openedTexts.splice(this.openedTexts.indexOf(index), 1);
            } else {
                this.openedTexts.push(index);
            }
        },
        isTextOpened (index) {
            return this.openedTexts.includes(index);
        },
        lines (text) {
            return text.content.split('\n');
        },
        getGroups() {
            ShutterApi.getGroups(this.user.locale).then(data => {
                ({syllableGroups: this.syllableGroups, wordGroups: this.wordGroups} = data);
            })
        },
        getTexts() {
            ShutterApi.getTexts(this.user.locale).then(data => {
                this.texts = data;
            })
        },
        closeManualInputModal () {
            this.params.sourceText = '';
            this.params.textLabel = '';
            this.showManualInputModal = false;
        },
        closeSelectTextModal () {
            this.params.sourceText = '';
            this.params.textLabel = '';
            this.showSelectTextModal = false;
        },
        handleClickOnText (text) {
            this.params.sourceText = text.content;
            this.params.textLabel = text.label;
            this.showSelectTextModal = false;
        },
        updateMetronomeSpeed (value) {
            this.params.metronomeSpeed = +value;
        },
        selectAllLettersForGroup(val) {
            if(!this.params[val] || this.params[val].length < this.groupOne.length) {
                if (val === 'Группа 1 (ма, ро)') {
                    this.$set(this.params, val, this.groupOne)
                }
                if (val === 'Группа 2 (мя, ки)') {
                    this.$set(this.params, val, this.groupTwo)
                }
                if (val === 'Группа 3 (ам, ор)') {
                    this.$set(this.params, val, this.groupThree)
                }
                if (val === 'Группа 4 (ям, ер)') {
                    this.$set(this.params, val, this.groupFour)
                }
            } else {
                this.params[val] = null;
            }
        },
        checkedValue(groupName) {
            if (this.params[groupName]) {
                return this.params[groupName].length === this.groupOne.length;
            }
        },
        checkSelectedGroups() {
            return false
        },
        speedLabel(amount) {
            return amount.value + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute')
        },
        decreaseAmountOfItemsInColumn() {
            if (this.params.amountOfItemsInColumn !== 1) {
                this.params.amountOfItemsInColumn -= 1;
            }
        },
        increaseAmountOfItemsInColumn() {
            if (this.params.amountOfItemsInColumn !== this.amountOfItemsInColumn) {
                this.params.amountOfItemsInColumn += 1;
            }
        },
        decreaseAmountOfWordsInRow() {
            if (this.params.amountOfWordsInRow !== 1) {
                this.params.amountOfWordsInRow -= 1;
            }
        },
        increaseAmountOfWordsInRow() {
            if (this.params.amountOfWordsInRow !== this.amountOfWordsInRow) {
                this.params.amountOfWordsInRow += 1;
            }
        },
        checkedSelectedGroups (type) {
            switch (type) {
                case 'wordColumn':
                    return this.params.selectedGroups.length === this.wordGroups.length;
            }
        },
        selectAllGroupsForView (type) {
            switch (type) {
                case 'wordColumn':
                    this.params.selectedGroups = _.cloneDeep(this.wordGroups);
                    break;
            }
        },
        removeAllGroupsForView() {
            this.params.selectedGroups = [];
        },
        toggleGroups() {
            if (this.params.selectedGroups.length < this.groups.length) {
                this.selectAllGroupsForView(this.params.mode);
            } else {
                this.removeAllGroupsForView();
                this.params.wordConstitutingLetters = clone(this.letters);
            }
        },
        toggleWordConstitutingLetters() {
            if (this.params.wordConstitutingLetters.length < this.letters.length) {
                this.params.wordConstitutingLetters = _.cloneDeep(this.letters);
            } else {
                this.params.wordConstitutingLetters = [];
            }
        },
        checkIfEnoughWords() {
            return ShutterApi.checkIfEnoughWords({
                locale: this.user.locale,
                type: this.params.mode === 'wordColumn' ? 'words' : 'syllables',
                groups: this.params.selectedGroups,
                groupsLetters: this.params.lettersForGroups,
            })
            .then(data => {
                return data.isEnoughWords;
            });
        },
      ...checkIfEnoughWordsBeforeSave
    },
    updated () {
        this.selectedGameMode = _.find(this.gameModes, { value: this.params.mode });
    },
    computed: {
        ...mapState({
            homework: state => state.trainer.homework,
            gamesParameters: state => state.trainer.gamesParameters,
            user: state => state.auth.user
        }),
        wordConstitutingLettersLength() {
            return this.params.wordConstitutingLetters?.length;
        },
        textsAccordingToLanguage () {
            return this.texts.filter(text => text.locale === this.params.textLanguage);
        },
        speeds () {
            return this.seconds.map(second => {
                let words = this.params.mode === 'wordColumn' ? 1 : this.params.amountOfWordsInRow;
                return {
                    value: Math.round((words / second) * SECONDS_IN_MINUTE),
                    showTime: second
                }
            });
        },
        isSaveButtonDisabled () {
            return this.params
              && (this.params.mode !== 'text' && this.params.selectedGroups.length < 1)
              || (this.params.mode === 'text' && (!this.params.sourceText || this.params.sourceText.length < 1))
              || (this.params.shutterSpeedIncrease && this.params.shutterMaxSpeed.showTime === this.params.shutterSpeed.showTime)
              || (this.checkSelectedGroups() && this.courseType !== 'fastReading');
        },
        groups () {
            return this.selectedGameMode?.value === 'wordColumn' ? this.wordGroups : this.syllableGroups;
        },
        amountOfItemsString () {
          return this.params.mode === 'wordColumn'
            ? this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInColumn')
            : this.$i18n.t('trainer.trainer_gameFormSetting_amountOfSyllablesInColumn');
        },
        invertedItemsString () {
            return this.params.mode === 'syllableColumn'
                ? this.$i18n.t('trainer.trainer_gameFormSetting_invertedSyllables')
                : this.$i18n.t('trainer.trainer_gameFormSetting_invertedWords')
        },
        selectedSyllableGroupsWithTwoLetters() {
            let currentArray = [];
            let newObject = {};
            currentArray = this.params.selectedGroups.filter(group => group.length > 14);
            for (let i = 0; i < currentArray.length; i++) {
                if (currentArray[i].includes('Группа 1 ')) {
                    newObject[i] = {
                        name: 'Группа 1 (ма, ро)',
                        letters: this.groupOne
                    }
                } else if (currentArray[i].includes('Группа 2 ')) {
                    newObject[i] = {
                        name: 'Группа 2 (мя, ки)',
                        letters: this.groupTwo
                    }
                } else if (currentArray[i].includes('Группа 3 ')) {
                    newObject[i] = {
                        name: 'Группа 3 (ам, ор)',
                        letters: this.groupThree
                    }
                } else if (currentArray[i].includes('Группа 4 ')) {
                    newObject[i] = {
                        name: 'Группа 4 (ям, ер)',
                        letters: this.groupFour
                    }
                }
            }
            return newObject;
        },
        selectedText () {
            return this.params.textLabel && this.params.sourceText
                && this.texts.find(text => text.label === this.params.textLabel && text.content === this.params.sourceText)
        },
        showWordConstitutingLettersFields() {
            return this.selectedGameMode && this.selectedGameMode.value === 'wordColumn' && this.checkedSelectedGroups('wordColumn')
                && this.slug === 'ShutterOnline';
        },
    },
    watch: {
        selectedGameMode (mode, oldMode) {
            if (oldMode) {
                if (mode.value === 'text') {
                    this.params.selectedGroups = [];
                    this.params.amountOfItemsInColumn = 1;
                } else if (
                  (oldMode.value === 'wordColumn' && mode.value === 'syllableColumn')
                  || (oldMode.value === 'syllableColumn' && mode.value === 'wordColumn')
                ) {
                  this.params.selectedGroups = [];
                } else {
                    this.params.amountOfWordsInRow = 1;
                    this.params.sourceText = '';
                    this.params.textLabel = '';
                }
            }
        },
        'params.selectedGroups'(val) {
            if (val.length !== 0 && this.groups.length !== 0 && val.length !== this.groups.length) {
                this.params.wordConstitutingLetters = clone(this.letters);
            }
        },
        'params.amountOfWordsInRow': {
            handler () {
                if (!this.params.shutterSpeed) this.params.shutterSpeed = this.speeds && this.speeds[0];
                if (!this.params.shutterMaxSpeed) this.params.shutterMaxSpeed = this.speeds && this.speeds[0];
            }
        },
    }
  }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .source-text {
        margin-top: 12px;
    }

    .trainer-modal-content, .trainer-modal-button {
        margin-top: 20px;
    }
    .trainer-modal-content__language-selector {
        display: flex;
        justify-content: center;
        font-size: 20px;
        font-weight: 500;
        @include stack-space($space-small)
    }

    .trainer-modal-content__language-multiselect {
        @include stack-space($space-large)
    }

    .trainer-modal-content__textarea {
        box-sizing: border-box;
        resize: none;
        width: 100%;
        padding: 10px;
        height: 250px;
        border: 1px solid $hsl-color-gray-74;
        border-radius: 5px;
        &:focus {
            outline: none;
        }
    }

    .trainer-modal-content__text-item {
        border: 1px solid $hsl-color-gray-74;
        padding: 10px;
        margin-bottom: 20px;
        border-radius: 10px;
        cursor: pointer;
        &:hover {
            background: $hsl-color-green-58;
        }
    }

    .trainer-modal-content__text-item--selected {
        background: $hsl-color-green-58;
    }

    .trainer-modal-content__noTextsMessage {
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        margin-top: 8%;
    }

    .trainer-modal-content__text-item__title {
        font-weight: 500;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
    }

    .trainer-modal-content__text-item__content {
        margin-top: 10px;
        font-size: 16px;
    }

    .warning {
        color: $hsl-color-red-62;
    }

    .button_with-margin {
        margin-right: 5px;
    }

    .form-select {
        width: 155px;
    }

    .label-select-all-letters {
        font-size: 14px;
        color: dimgray;
        display: block;
        text-align: right;
        @media screen and (max-device-width: 768px) {
            text-align: left;
        }
    }

    .is-selected {
        color: $hsl-color-green-48;
        text-shadow: 0 0 2px $hsl-color-green-58;
        text-transform: uppercase;
    }

    .select-text {
        width: 50%;
    }
</style>
